export default __webpack_public_path__ + "assets/icons/icon-location-black.da429c9ec7ae39ddafc270bc573b08e1.svg";